import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function silent(fn) {
  return function () {
    try {
      return fn.apply(void 0, arguments);
    } catch (e) {
      if (typeof console !== 'undefined' && console.error) {
        console.error(e);
      }
      return null;
    }
  };
}
silent.async = function (fn) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fn.apply(void 0, _args);
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          if (typeof console !== 'undefined' && console.error) {
            console.error(_context.t0);
          }
          return _context.abrupt("return", null);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
};
export default silent;